export default "__VITE_ASSET__5a8f1c1d__"